import { Injectable } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { BehaviorSubject, Observable,Subject } from 'rxjs';
import { __values } from 'tslib';


@Injectable({
  providedIn: 'root'
})
export class DataService {
  printReconciliationData(tempdata: any[]) {
    throw new Error('Method not implemented.');
  }

  public approvalStageMessage = new BehaviorSubject('0');
  currentApprovalStageMessage = this.approvalStageMessage.asObservable();

  
  data: any = [];
  public myData: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public favLedger: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public tmpLedgers: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public tmpdataTransfer: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public tmpItems: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public tmpStockItems: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public tmpStore: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public tmpWIPDetails:BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);

  public headData : BehaviorSubject<any> = new BehaviorSubject<any[]>([]);
  //For ProductDetails Modal
  public tmpByProduct: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public tmpProductStages: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public tmpProductUnits: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public tmpBOMData: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public tmpVoucherEntered: BehaviorSubject<any> = new BehaviorSubject<any>('0');
  public tmpStageEntered: BehaviorSubject<any> = new BehaviorSubject<any>('0');
  public tmpLedgerRecord: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public tmpLedgerRecordPrintData: BehaviorSubject<any> = new BehaviorSubject<any>('');

  //Open Move Job Modal
  public tmpMoveJobModal: BehaviorSubject<any> = new BehaviorSubject<any>({});
  public tmpFinancialYearChange : BehaviorSubject<any> = new BehaviorSubject<any[]>([]);
  public tmpBatchesData: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public tmpProjectData: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public tmpRecoBatchesData: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public tmpDocData: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public tmpTaskEntryData: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  

  

  tmpMyData = this.myData.asObservable();
  favLedgerData = this.favLedger.asObservable();
  Ledger = this.tmpLedgers.asObservable();
  dataTransfer = this.tmpdataTransfer.asObservable();
  items = this.tmpItems.asObservable();
  stockItems = this.tmpStockItems.asObservable();
  store = this.tmpStore.asObservable();
  WIPDetails = this.tmpWIPDetails.asObservable();
  voucherEntered = this.tmpVoucherEntered.asObservable();
  stageEntered = this.tmpStageEntered.asObservable();
  moveJobModal = this.tmpMoveJobModal.asObservable();

  //For ProductDetails Modal
  BOMData = this.tmpBOMData.asObservable();
  LedgerRecordData = this.tmpLedgerRecord.asObservable();
  LedgerRecordPrintData = this.tmpLedgerRecordPrintData.asObservable();

  byProduct = this.tmpByProduct.asObservable();
  productStages = this.tmpProductStages.asObservable();
  productUnits = this.tmpProductUnits.asObservable();
  financialYearChange = this.tmpFinancialYearChange.asObservable();
  batches = this.tmpBatchesData.asObservable();
  projectData = this.tmpProjectData.asObservable();
  recoBatchData = this.tmpRecoBatchesData.asObservable();
  docData = this.tmpDocData.asObservable();
  taskEntryData = this.tmpTaskEntryData.asObservable();


// for headDetails modal
  headDetails = this.headData.asObservable();

  trainingModule: any = {
    moduleID: 0,
    videoID: "",
    thumbnailID: "",
    showVideo: false,
    isActive: false
  };
  sanitizedURL: SafeResourceUrl | null = null;
  
  constructor(private sanitizer: DomSanitizer) { }

  updateApprovalMessage(message: string) {
    this.approvalStageMessage.next(message)
  }

  updateData(data: any){
    this.myData.next(data);
  }

  getFavLedger(data: any){
    this.favLedger.next(data);
  }

  updateLedger(data: any){
    this.tmpLedgers.next(data);
  }

  fn_dataTransfer(data: any){
    this.tmpdataTransfer.next(data);
  }
  
  updateItems(data: any) {
    this.tmpItems.next(data);
  }

  updateStockItems(data: any) {
    this.tmpStockItems.next(data);
  }

  updateStore(data: any){
    this.tmpStore.next(data); 
  }

  updateWIPDetails(data: any){
    this.tmpWIPDetails.next(data); 
  }

  //For Product Details Modal
  updateBOMData(data: any){
    this.tmpBOMData.next(data); 
  }

  updateLedgerRecordData(data: any){
    this.tmpLedgerRecord.next(data);
  }

  ledgerRecordPrintData(data: any){
    this.tmpLedgerRecordPrintData.next(data);
  }

  updateByProduct(data: any){
    this.tmpByProduct.next(data); 
  }

  updateProductStages(data: any){
    this.tmpProductStages.next(data); 
  }

  updateProductUnits(data: any) {
    this.tmpProductUnits.next(data);
  }

  updateVoucherEntered(data: any){
    this.tmpVoucherEntered.next(data);
  }

  updateStageEntered(data: any){
    this.tmpStageEntered.next(data);
  }

  updateMoveJobModal(data: any) {
    this.tmpMoveJobModal.next(data);
  }

  headDatas(data : any) {
    this.headData.next(data);
  }

  updateFinancialYearChange(data: any){
    this.tmpFinancialYearChange.next(data);
  }
  //For Product Details Modal
  updateBathesData(data: any){
    this.tmpBatchesData.next(data); 
  }

  //For project Details Modal
   updateProjectData(data: any){
    this.tmpProjectData.next(data); 
  }

  //For Product Details Modal
  updateRecoBatchData(data: any){
    this.tmpRecoBatchesData.next(data); 
  }
 
  // For suggest profile modal
  updateDocID(data: any){
    this.tmpDocData.next(data); 
  }

  // For sending message to parent child about task entry
  updateTaskEntryData(data: any){
    this.tmpTaskEntryData.next(data); 
  }

  // trainingVideoActions() - Controls for training video in modal that opens for the first time
  trainingVideoActions = (action: string, videoCode: number) => {
    let videoID = "", thumbnailID = "";
    this.trainingModule.moduleID = videoCode;
    switch (videoCode) {
        // CRM Section
        case 1:
            videoID = "ch3VGEvq71U";
            thumbnailID = "Training_Leads.png";
            break;
        case 2: // Leads, Prospects
            videoID = "ch3VGEvq71U";
            thumbnailID = "Training_Prospects.png";
            break;
        case 3: // Quotes
            videoID = "NzV7te7hlvQ";
            thumbnailID = "Training_Quotes.png";
            break;
        case 4: // Orders
            videoID = "mNIWgM-LNCk";
            thumbnailID = "Training_SalesOrders.png";
            break;
        case 5: // Invoice
            videoID = "9ozE_1ZwDTo";
            thumbnailID = "Training_Invoices.png";
            break;
        case 6: // Recovery
            videoID = "DYtcAL_fWsQ";
            thumbnailID = "Training_Recovery.png";
            break;
        case 7: // Contracts
            videoID = "p6om4ypeTgM";
            thumbnailID = "Training_Contracts.png";
            break;
        case 8: // Support
            videoID = "3D2e5tNJ__g";
            thumbnailID = "Training_Support.png";
            break;
        // ERP
        case 9: // Accounts
            videoID = "shpal04wsuA";
            thumbnailID = "Training_Accounts.png";
            break;
        case 10: // Purchase
            videoID += "mP8NeCqtUuk";
            thumbnailID = "Training_Purchases.png";
            break;
        case 11: // Purch Order
            videoID = "MXzi0GKkPHY";
            thumbnailID = "Training_PurchOrders.png";
            break;
        case 12: // Inventory
            videoID = "KdzUWGZfIzI";
            thumbnailID = "Training_Inventory.png";
            break;
        case 13: // Production
            videoID = "dFkyE3x0m3s";
            thumbnailID = "Training_Manufacturing.png";
            break;
        case 14: // Tasks
            videoID = "S7UGtxdujIs";
            thumbnailID = "Training_Tasks.png";
            break;
        default:
            break;
    }

    if (action == "open") {
        window.open("https://youtu.be/" + videoID, "_blank");
    }
    else if (action == "play") {
        const url = `https://www.youtube.com/embed/${videoID}?autoplay=1`;
        this.sanitizedURL = this.sanitizer.bypassSecurityTrustResourceUrl(url);
         this.trainingModule.videoID = this.sanitizedURL;
        this.trainingModule.showVideo = true;
    }
    else if (action == "stop") {
        this.trainingModule.showVideo = false;
        this.trainingModule.videoID = null;
    }
    else if (action == "active")
    {
        this.trainingModule.thumbnailID = "/ERP/assets/images/Training/" + thumbnailID;
        this.trainingModule.showVideo = false;
        this.trainingModule.isActive = true;
        
    }
    console.log(this.trainingModule);
}
}
